<script>
  export let user;

</script>

<h1>Hello {user?.id?._lastValue}</h1>